import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || '/api';
console.log('🌐 [API Base]:', baseURL);

const api = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token automatically
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('rc_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      // NO redirigir en login/registro: el formulario debe mostrar su propio
      // error ("Credenciales incorrectas"). Tampoco en change-password: ahí un
      // 401 significa "la contraseña actual es incorrecta", no sesión expirada,
      // y expulsar al usuario del panel por un error de formulario sería mal UX.
      const isAuth = ['/auth/login', '/auth/registro', '/auth/change-password']
        .some(p => err.config?.url?.includes(p));
      if (!isAuth && localStorage.getItem('rc_token')) {
        localStorage.removeItem('rc_token');
        localStorage.removeItem('rc_user');
        window.location.href = '/';
      }
    }
    console.error('📡 [API Error Detail]:', {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
      config: err.config
    });
    return Promise.reject(err);
  }
);

export default api;
